<template>
  <div>
    <div class="mb-5">
      <div class="row">
        <div class="col-md-7">
          <h6 class="fw-bold">Fixed Layout</h6>
          <div class="card">
            <div class="card-header text-uppercase">8 Squared Main Menu</div>
            <div class="d-flex flex-column p-2">
              <span class="fsize-14 fw-bold ps-2 my-3 text-danger">Visible Menu</span>
              <div v-for="(item, index) in mainMenu.slice(0, visibleMenuLength)" :key="index" class="card px-2 py-3 mb-3 border-0 custom-shadow">
                <div class="d-flex align-items-center">
                  <div>
                    <span class="fw-bold me-3">Display Name</span>
                  </div>

                  <div class="flex-fill me-4" style="display: inline-flex; align-items: center;">
                    <input type="text" class="form-control" placeholder="Enter display name" v-model="item.label"
                           maxlength="20" style="border-right: 0; border-top-right-radius: 0;border-bottom-right-radius: 0;"/>
                    <span class="input-group-text" style="background-color: white; border-left: 0; border-top-left-radius: 0;border-bottom-left-radius: 0;">
                    {{ item?.label?.length || 0 }}/20
                  </span>
                  </div>

                  <div class="me-4 px-3 py-2" style="background-color: #f3f2f8">
                    <a v-if="item.icon_url === '' || item.icon_url == null" @click="changeImageModal(index)">
                      <font-awesome-icon icon="fa-solid fa-plus"/>
                    </a>
                    <img v-else @click="changeImageModal(index)" :src="item.full_path" :alt="item.label" class="flex-fill"
                         style="max-height: 12px; max-width: fit-content">
                  </div>
                  <div class="flex-fill flex-column me-4">
                    <input type="text" class="form-control" placeholder="Choose category"
                           :disabled="disableList.includes(item.name)"
                           v-model="item.name" @focusin="openModalCategory('mainMenu', index)">
                  </div>
                  <div class="d-flex fw-bold me-3">
                    <a @click="moveUp(index, 'mainMenu')" v-if="index !== 0" style="color: #5e50a1">
                      <font-awesome-icon icon="fa-solid fa-arrow-up"/>
                    </a>
                    <font-awesome-icon v-else icon="fa-solid fa-arrow-up"/>

                    <a @click="moveDown(index, 'mainMenu')" class="ms-2" v-if="index !== visibleMenuLength - 1">
                      <font-awesome-icon icon="fa-solid fa-arrow-down"/>
                    </a>
                    <font-awesome-icon v-else class="ms-2" icon="fa-solid fa-arrow-down"/>
                  </div>
                </div>
                <div v-show="item.date_end"><span class="float-end mt-1 text-danger" style="margin-right: 14.5rem">Category Promo is expired</span></div>
              </div>

              <span class="fsize-14 fw-bold ps-2 my-3 text-danger">Other Menu</span>
              <div v-for="(item, index) in mainMenu.slice(visibleMenuLength)" :key="index+visibleMenuLength" class="card px-2 py-3 mb-3 border-0 custom-shadow">
                <div class="d-flex align-items-center">
                  <div>
                    <span class="fw-bold me-3">Display Name</span>
                  </div>

                  <div class="flex-fill me-4" style="display: inline-flex; align-items: center;">
                    <input type="text" class="form-control" placeholder="Enter display name" v-model="item.label"
                           maxlength="20" style="border-right: 0; border-top-right-radius: 0;border-bottom-right-radius: 0;"/>
                    <span class="input-group-text" style="background-color: white; border-left: 0; border-top-left-radius: 0;border-bottom-left-radius: 0;">
                    {{ item?.label?.length || 0 }}/20
                  </span>
                  </div>

                  <div class="me-4 px-3 py-2" style="background-color: #f3f2f8">
                    <a v-if="item.icon_url === '' || item.icon_url == null" @click="changeImageModal(index+visibleMenuLength)">
                      <font-awesome-icon icon="fa-solid fa-plus"/>
                    </a>
                    <img v-else @click="changeImageModal(index+visibleMenuLength)" :src="item.full_path" :alt="item.label" class="flex-fill"
                         style="max-height: 12px; max-width: fit-content">
                  </div>
                  <div class="flex-fill flex-column me-4">
                    <input type="text" class="form-control" placeholder="Choose category"
                           :disabled="disableList.includes(item.name)"
                           v-model="item.name" @focusin="openModalCategory('mainMenu', index+visibleMenuLength)">
                  </div>
                  <div class="d-flex fw-bold me-2">
                    <a @click="moveUp(index+visibleMenuLength, 'mainMenu')" v-if="index !== 0" style="color: #5e50a1">
                      <font-awesome-icon icon="fa-solid fa-arrow-up"/>
                    </a>
                    <font-awesome-icon v-else icon="fa-solid fa-arrow-up"/>

                    <a @click="moveDown(index+visibleMenuLength, 'mainMenu')" class="ms-2" v-if="index+visibleMenuLength !== mainMenu.length - 1">
                      <font-awesome-icon icon="fa-solid fa-arrow-down"/>
                    </a>
                    <font-awesome-icon v-else class="ms-2" icon="fa-solid fa-arrow-down"/>
                  </div>
                  <div class="d-flex fw-bold">
                    <a @click="deleteRow(index+visibleMenuLength)" class="ms-2 me-2">
                      <font-awesome-icon icon="fa-solid fa-trash"/>
                    </a>
                  </div>
                </div>
                <div v-show="item.date_end"><span class="float-end mt-1 text-danger" style="margin-right: 14.5rem">Category Promo is expired</span></div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <button @click="saveDataCategory()" type="button" class="btn btn-danger text-white me-3">
              UPDATE
            </button>
            <button @click="addOtherRow()" type="button" class="btn btn-danger text-white text-uppercase">
              Add Other Menu
            </button>
          </div>
        </div>
        <div class="col-md-5">
          <h6 class="fw-bold">Rearrangable Layout</h6>
          <div class="card">
            <div class="card-header d-flex justify-content-between">
              <div class="text-uppercase">Product Carousel : {{ this.group[0].section_name }}</div>
              <div>
                <a @click="openModalCategory('group', 0)">
                  <font-awesome-icon icon="fa-solid fa-gear"/>
                </a>
              </div>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Total Products : {{ this.group[0].product_count }} <span v-show="this.group[0].date_end" class="ms-3 text-danger">Category Promo is expired</span></li>
            </ul>
          </div>
          <br/>
          <div class="card">
            <div class="card-header d-flex justify-content-between">
              <div class="text-uppercase">Product Grid : {{ this.group[1].section_name }}</div>
              <div>
                <a @click="openModalCategory('group', 1)">
                  <font-awesome-icon icon="fa-solid fa-gear"/>
                </a>
              </div>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Total Products : {{ this.group[1].product_count }} <span v-show="this.group[1].date_end" class="ms-3 text-danger">Category Promo is expired</span></li>
            </ul>
          </div>
          <br/>
          <div class="card">
            <div class="card-header d-flex justify-content-between">
              <div class="text-uppercase">Product Carousel : {{ this.group[2].section_name }}</div>
              <div>
                <a @click="openModalCategory('group', 2)">
                  <font-awesome-icon icon="fa-solid fa-gear"/>
                </a>
              </div>
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Total Products : {{ this.group[2].product_count }} <span v-show="this.group[2].date_end" class="ms-3 text-danger">Category Promo is expired</span></li>
            </ul>
          </div>
          <br/>
          <div class="card">
            <div class="card-header d-flex justify-content-between">
              <div class="text-uppercase">Product Combo :</div>
              <div>
                <font-awesome-icon icon="fa-solid fa-gear"/>
              </div>
            </div>
            <ul class="list-group list-group-flush p-2">
              <div v-for="(item, index) in productCombo" :key="index" class="card d-flex p-2 mb-3 border-0 custom-shadow">
                <div class="d-flex align-items-center">
                  <div class="input-group flex-fill me-4">
                    <input v-model="item.label"
                           type="text"
                           class="form-control"
                           placeholder="Display name"
                           maxlength="20"
                           style="border-right: 0; border-top-right-radius: 0;border-bottom-right-radius: 0;"
                    />
                    <span class="input-group-text" style="background-color: white;  border-left: 0; border-top-left-radius: 0;border-bottom-left-radius: 0;">
                    {{ item?.label?.length || 0 }}/20
                  </span>
                  </div>
                  <div class="flex-fill me-4">
                    <input type="text" class="form-control" placeholder="Choose category"
                           v-model="item.category_name" @focusin="openModalCategory('productCombo', index)">
                  </div>
                  <div class="d-flex fw-bold me-3">
                    <a @click="moveUp(index, 'productCombo')" v-if="index !== 0" style="color: #5e50a1">
                      <font-awesome-icon icon="fa-solid fa-arrow-up" class="fa-primary"/>
                    </a>
                    <font-awesome-icon v-else icon="fa-solid fa-arrow-up"/>

                    <a @click="moveDown(index, 'productCombo')" class="ms-2" v-if="index !== productCombo.length - 1">
                      <font-awesome-icon icon="fa-solid fa-arrow-down"/>
                    </a>
                    <font-awesome-icon v-else class="ms-2" icon="fa-solid fa-arrow-down"/>
                  </div>
                </div>
                <div class="mt-1" v-show="item.date_end"><span class="float-end text-danger" style="margin-right: 4.5rem">Category Promo is expired</span></div>
              </div>
            </ul>
          </div>
          <div class="mt-3">
            <button @click="saveDataTab()" type="button" class="btn btn-danger text-white">
              UPDATE
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <transition name="modal-category">
    <div v-if="showModalCategory">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 id="exampleModalLabel" class="modal-title">SELECT CATEGORY</h5>
                <button aria-label="Close" class="btn-close" type="button"
                        @click="showModalCategory = false"></button>
              </div>
              <div class="modal-body">
                <div v-if="displayNameForm" class="mb-3 row">
                  <label class="col-sm-3 col-form-label" for="inputDate">Display Name</label>
                  <div class="col-sm-9" style="display: inline-flex; align-items: center;">
                    <input v-model="displayNameForm" class="form-control" type="text" maxlength="24" style="border-right: 0; border-top-right-radius: 0;border-bottom-right-radius: 0;">
                    <span class="input-group-text" style="background-color: white; border-left: 0; border-top-left-radius: 0;border-bottom-left-radius: 0;">
                    {{ displayNameForm?.length || 0 }}/24
                  </span>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-3 col-form-label" for="staticDay">Category Type</label>
                  <div class="col-sm-9">
                    <select v-model="categoryTypeSelected" @change="fetchCategory()" class="form-select">
                      <option value="category-product">Category Product</option>
                      <option value="category-promo">Category Promo</option>
                    </select>
                  </div>
                </div>
                <div class="mb-3 row">
                  <label class="col-sm-3 col-form-label" for="adminFee">Category</label>
                  <div class="col-sm-9">
                    <select v-model="categorySelected" class="form-select">
                      <option v-for="data in category" :key="data.id" :value="data.id">
                        {{ data.value }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="mb-3 row" v-if="categoryTypeSelected === 'category-product'">
                  <label class="col-sm-3 col-form-label" for="inputNote">Sub Category</label>
                  <div class="col-sm-9">
                    <select v-model="subCategorySelected" class="form-select">
                      <option
                          v-for="data in subCategory.filter((item) => item.parent_category_id === categorySelected)"
                          :key="data.id" :value="data.id">
                        {{ data.value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-outline-danger fw-bold text-uppercase" type="button" @click="showModalCategory = false">
                  Close
                </button>
                <button class="btn btn-danger text-white fw-bold text-uppercase" type="button" @click="updateData()">
                  UPDATE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <transition name="modal-category">
    <div v-if="showModalUploadIcon">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 id="exampleModalLabel" class="modal-title">SELECT CATEGORY</h5>
                <button aria-label="Close" class="btn-close" type="button"
                        @click="showModalUploadIcon = false"></button>
              </div>
              <div class="modal-body">
                <div class="d-flex flex-column">
                  <div 
                    class="file-input btn btn-light rounded"
                    style="width:fit-content;"
                  >
                    <input 
                      type="file" 
                      id="file" 
                      class="file"
                      accept="image/*"
                      @change="readURL"/>
                    <label for="file">
                      <img v-if="iconSelected" :src="iconSelected"/>
                      <template v-else>
                        <font-awesome-icon icon="fa-solid fa-plus"/>
                        Choose file
                      </template>
                    </label>
                  </div>
                  <span v-if="error" class="mt-3 text-danger">{{error}}</span>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-outline-danger fw-bold text-uppercase" type="button" @click="showModalUploadIcon = false">
                  Close
                </button>
                <button :disabled="!selectedFiles" class="btn btn-danger text-white fw-bold text-uppercase" type="button" @click="uploadIcon()">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      disableList: ['Voucher Saya', 'Other Menu'],
      visibleMenuLength: 11,
      error: "",
      displayNameForm: null,
      showModalUploadIcon: false,
      showModalCategory: false,
      categoryTypeSelected: null,
      categorySelected: null,
      subCategorySelected: null,
      selectedFiles: null,
      iconSelected: null,
      targetType: null,
      targetIndex: 0,
      categoryType: [
        {id: null, value: 'Choose category type.'}
      ],
      category: [],
      subCategory: [],
      selected: '',
      mainMenu: [],
      productCombo: [],
      group: [
        {
          type: 'product_small_item_list',
          name: 'Product carousel',
          section_name: null,
          category_id: null,
          category_name: null,
        },
        {
          type: 'product_large_item_list',
          name: 'Product grid',
          section_name: null,
          category_id: null,
          category_name: null,
        },
        {
          type: 'product_small_item_list',
          name: 'Product carousel',
          section_name: null,
          category_id: null,
          category_name: null,
        },
      ],
    }
  },
  methods: {
    changeImageModal(index) {
      this.error = ""
      this.iconSelected = null
      this.selectedFiles = null;
      this.showModalUploadIcon = true
      this.targetIndex = index
    },
    readURL(e) {
      this.error = ""
      this.selectedFiles = null;
      this.iconSelected = null;
      const file = e.target.files[0];

      if(!file) return

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        const src = e.target.result;
        const img = new Image();
        img.onload = () => {
          this.width = img.width
          this.height = img.height

          if (file.size > 100000) {
            this.error = "Size Image Too Large"
          } else if (this.width < 48 || this.height != this.width) {
            this.showAlert = true
            this.error = "Width And Height resolution less than 48x48 or ratio not 1x1"
          } else {
            this.selectedFiles = file;
            this.iconSelected = URL.createObjectURL(file);
          }
        };
        img.src = src
      }
    },
    async uploadIcon() {
      let payload = new FormData();
      payload.append("icon", this.selectedFiles);

      try{
        const response = await this.$store.dispatch("marketing/uploadIcon", payload);

        this.mainMenu[this.targetIndex].icon_url = response.gcs_path
        this.mainMenu[this.targetIndex].full_path = `${process.env.VUE_APP_STORAGE}${response.gcs_path}`
        this.iconSelected = null

        this.showModalUploadIcon = false
      }catch(err){
        console.log({err})
        this.$swal({
          icon: "error",
          title: 'Something Went Wrong',
          text: "Failed Send Request",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    moveUp(index, type) {
      if (type === 'mainMenu') {
        const currentMenu = this.mainMenu[index - 1]
        currentMenu.sequence = index - 1

        const movingMenu = this.mainMenu[index]
        movingMenu.sequence = index

        this.mainMenu[index] = currentMenu
        this.mainMenu[index - 1] = movingMenu
      } else {
        const currentList = this.productCombo[index - 1]
        currentList.sequence = index - 1

        const movingList = this.productCombo[index]
        movingList.sequence = index

        this.productCombo[index] = currentList
        this.productCombo[index - 1] = movingList
      }
    },
    moveDown(index, type) {
      if (type === 'mainMenu') {
        const currentMenu = this.mainMenu[index + 1]
        currentMenu.sequence = index + 1

        const movingMenu = this.mainMenu[index]
        movingMenu.sequence = index

        this.mainMenu[index] = currentMenu
        this.mainMenu[index + 1] = movingMenu
      } else {
        const currentList = this.productCombo[index + 1]
        currentList.sequence = index + 1

        const movingList = this.productCombo[index]
        movingList.sequence = index

        this.productCombo[index] = currentList
        this.productCombo[index + 1] = movingList
      }
    },
    deleteRow(index) {
      this.mainMenu.splice(index, 1)
    },
    addOtherRow() {
      this.mainMenu.push({
        full_path: null,
        icon_url: null,
        id: null,
        key: null,
        label: null,
        name: null,
        sequence: this.mainMenu.length,
        url: null
      })
    },
    openModalCategory(type, index) {
      this.displayNameForm = null
      this.showModalCategory = true
      this.targetType = type
      this.targetIndex = index
      this.categoryTypeSelected = null
      this.categorySelected = null
      this.subCategorySelected = null

      let categoryId = []

      if (type === 'mainMenu') {
        categoryId = this.mainMenu[index].key.split('-')
      } else if (type === 'productCombo') {
        categoryId = this.productCombo[index].category_id.split('-')
      } else {
        categoryId = this.group[index].category_id.split('-')
        this.displayNameForm = this.group[index].section_name
      }

      this.categorySelected = categoryId[0]

      if (categoryId.length > 1) {
        this.subCategorySelected = categoryId.join('-')
        this.categoryTypeSelected = 'category-product'
      } else {
        this.categoryTypeSelected = 'category-promo'
      }

      this.fetchCategory()
    },
    /**
     * TODO, buat state untuk nampung fetch category product/promo
     * yg dimana cukup hit 1x saat mount, kedepanny jika data makin banyak
     * performa akan kerasa lambatny
     */
    async fetchCategory() {
      try{
        this.$store.dispatch("setLoadingGlobal", true)
        if (this.categoryTypeSelected === 'category-product') {
          let categoryProduct = await this.$store.dispatch("product/getAllCategoryProduct", {size: 9999})
  
          categoryProduct = categoryProduct.items.map(item => {
            return {id: item.id, value: item.name, parent_category_id: item.parent_category_id}
          })
  
          this.category = categoryProduct.filter((item) => item.parent_category_id === '')
          this.subCategory = categoryProduct.filter((item) => item.parent_category_id !== '')
  
        } else if (this.categoryTypeSelected === 'category-promo') {
          this.subCategorySelected = null;
  
          const categoryPromo = await this.$store.dispatch("product/getAllCategoryPromo", {size: 9999})
          this.category = categoryPromo.items.map(item => {
            return {id: item.id, value: item.name}
          })
        }
      }catch(err){
        console.log({err})
      }finally{
        this.$store.dispatch("setLoadingGlobal", false)
      }
    },
    async setProductCount(index, categoryId) {
      await this.$store.dispatch("product/getAllProductByCategory", categoryId).then((result) => {
        this.group[index].product_count = result.items.length
      }).catch(() => {
        this.group[index].product_count = 0
      })
    },
    updateData() {
      let key = this.categorySelected
      let name = this.category.find((value) => value.id === this.categorySelected)
      let url = 'promo'

      if (this.subCategorySelected) {
        key = this.subCategorySelected
        name = this.subCategory.find((value) => value.id === this.subCategorySelected)
        url = 'product'
      }

      if (this.targetType === 'mainMenu') {

        this.mainMenu[this.targetIndex].key = key
        this.mainMenu[this.targetIndex].name = name.value
        this.mainMenu[this.targetIndex].url = url

      } else if (this.targetType === 'productCombo') {

        this.productCombo[this.targetIndex].category_id = key
        this.productCombo[this.targetIndex].category_name = name.value
        this.productCombo[this.targetIndex].url = url

      } else {

        this.group[this.targetIndex].category_id = key
        this.group[this.targetIndex].category_name = name.value
        this.group[this.targetIndex].section_name = this.displayNameForm

        this.setProductCount(this.targetIndex, key)

      }

      this.showModalCategory = false
    },
    async saveDataCategory() {
      await this.$store.dispatch("marketing/saveDataCategory", {categories: this.mainMenu})

      this.$swal({
        icon: "success",
        title: "Success save data category.",
        showConfirmButton: false,
        timer: 1500,
      })
    },
    parseCategoryType(id){
      if(id?.split('-')?.length > 1){
        return "product"
      }

      return "promo"
    },
    async saveDataTab() {
      let finalTabs = this.productCombo.filter((item) => item.label).map(data=>{
        return {
          ...data,
          category_type: this.parseCategoryType(data.category_id)
        }
      })
      let finalGroups = this.group.map(data=>{
        return {
          ...data,
          category_type: this.parseCategoryType(data.category_id)
        }
      })
      const payload = {
        tabs: finalTabs,
        groups: finalGroups,
      }

      await this.$store.dispatch("marketing/saveDataTab", payload)

      this.$swal({
        icon: "success",
        title: "Success save data tab.",
        showConfirmButton: false,
        timer: 1500,
      })
    }
  },
  async mounted() {
    try {
      this.$store.dispatch("setLoadingGlobal", true)
      const response = await this.$store.dispatch("marketing/fetch");
  
      let homepageCategory = []
  
      if (response.homepage_category) {
        homepageCategory = response.homepage_category
        
        const foundOtherMenu = homepageCategory.find((item) => {
          return item.name === 'Other Menu'
        })
        
        const foundVoucherSaya = homepageCategory.find((item) => {
          return item.name === 'Voucher Saya'
        })
        
        if (!foundVoucherSaya) {
          homepageCategory.splice(9, 0, {
            full_path: null,
            icon_url: null,
            id: null,
            key: null,
            label: null,
            name: 'Voucher Saya',
            sequence: homepageCategory.length,
            url: null
          })
        }
        
        if (!foundOtherMenu) {
          homepageCategory.splice(10, 0, {
            full_path: null,
            icon_url: null,
            id: null,
            key: null,
            label: null,
            name: 'Other Menu',
            sequence: homepageCategory.length,
            url: null
          })
        }
        
      }
  
      while (homepageCategory.length < 11) {
        homepageCategory.push({
          full_path: null,
          icon_url: null,
          id: null,
          key: null,
          label: null,
          name: null,
          sequence: homepageCategory.length,
          url: null
        })
      }
  
      this.mainMenu = homepageCategory;
  
      let homepageTab = [];
  
      if (response.homepage_tab) {
        homepageTab = response.homepage_tab?.sort((item) => item.sequence)
      }
  
      while (homepageTab.length < 8) {
        homepageTab.push({
          category_id: null,
          category_name: null,
          id: null,
          label: null,
          sequence: homepageCategory.length,
        })
      }
  
      this.productCombo = homepageTab;
  
      if (response.homepage_group) {
        let arr = []
        let promiseArr = []
        response.homepage_group.forEach((item, index) => {
          const payload = {
            type: item.type,
            name: item.name,
            date_end: item.date_end,
            section_name: item.detail.section_name,
            category_id: item.detail.category_id,
            category_name: item.detail.category_name,
            category_type: item.category_type
          }
  
          promiseArr.push(this.setProductCount(index, payload.category_id))
          arr.push(payload)
        })
        this.group = arr
        await Promise.all(promiseArr)
        console.log({arr})
      }
    }catch(err){
      console.log({err})
    }finally{
      this.$store.dispatch("setLoadingGlobal", false)
    }

  },
};
</script>

<style scoped>
.custom-shadow{
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}
.form-select:focus, .form-control:focus {
  box-shadow: none !important;
  border: 1px solid #ced4da;
}

span.input-group-text {
  color: #87878b;
  min-width: 40px;
  place-content: end;
  padding-left: 0;
}

.modal-mask {
  position: fixed;
  z-index: 1100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-dialog {
  min-height: calc(100% - 3.5rem);
  max-width: 500px;
  margin: 1.75rem auto;
  display: flex;
  align-items: center;
  position: relative;
  width: auto;
  pointer-events: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  max-width: inherit;
  height: inherit;
  margin: 0 auto;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

.modal-footer>* {
  margin: 0.25rem;
}


</style>
